// Type mapping for different contact reasons
const typeMap = {
  Sales: 'missions@transastra.com',
  Career: 'careers@transastra.com',
  Media: 'media@transastra.com',
  Invest: 'invest@transastra.com',
  Other: 'missions@transastra.com',
};

export async function sendMessage(formData, toast) {
  console.log("Opening email client with data: ", formData);
  try {
    // Get the appropriate email address based on the contact reason
    const toEmail = typeMap[formData.reasonForContact] || 'missions@transastra.com';
    
    // Build the email body with all the form information
    const emailBody = `Name: ${formData.name}
Organization: ${formData.organization || 'N/A'}
Email: ${formData.email}
Phone: ${formData.phone || 'N/A'}

Message:
${formData.message}`;

    // Encode the subject and body for URL
    const subject = encodeURIComponent(formData.subject);
    const body = encodeURIComponent(emailBody);
    
    // Create the mailto link
    const mailtoLink = `mailto:${toEmail}?subject=${subject}&body=${body}`;
    
    // Try using window.open which works better in some browsers
    window.open(mailtoLink, '_self');
    
    toast.success("Opening your email client...");
    return true;
  } catch (e) {
    console.error("Error opening email client: ", e);
    toast.error("Error opening email client");
    return false;
  }
}
